(function (angular) {
	'use strict';

	angular
		.module('PinMeTo.services')
		.service('pmtSiteInfoService', function (pmtSiteService, pmtEnvService) {
			var self = this;
			self.addWork = addWork;
			self.subscribeToWork = subscribeToWork;
			self.subscribeToNotifications = subscribeToNotifications;

			var siteInfo = {
				work: {},
				notifications: []
			};

			var sitePromise = pmtSiteService.getSite();

			function addWork() {
				siteInfo.work.inProgress = siteInfo.work.inProgress ? siteInfo.work.inProgress + 1 : 1;
				sendWork();
			}

			var createWebsocket = function () {
				sitePromise.then(function (site) {
					if (!site) return;

					var baseUrl = pmtEnvService.listingsManagerUrl
						.replace('https', 'wss')
						.replace('http', 'ws')
						.replace('/listings/', '/');
					var socketUrl = baseUrl + 'info';

					var work = io.connect(socketUrl, {
						query: 'site=' + site.name,
						transports: ['websocket'],
						path: '/listings/socket.io'
					});

					work.on('work', function (data) {
						siteInfo.work = data;
						sendWork();
					});

					work.on('notifications', function (data) {
						if (site.name === data.siteName) {
							siteInfo.notifications = data.notifications;
							sendNotifications();
						}
					});

					work.on('listenRespond', (/*data*/) => {});
				});
			};

			function subscribeToNotifications(callback) {
				subscribe('Notifications', callback);
				sendNotifications();
			}
			function subscribeToWork(callback) {
				subscribe('Work', callback);
				sendWork();
			}

			function sendNotifications() {
				message('Notifications', siteInfo.notifications);
			}
			function sendWork() {
				message('Work', siteInfo.work);
			}

			var subscribers = {};
			function subscribe(key, callback) {
				if (!subscribers[key]) {
					subscribers[key] = [];
				}
				subscribers[key].push(callback);
			}
			function message(key, message) {
				if (subscribers[key]) {
					subscribers[key].forEach(function (subscriber) {
						subscriber(message);
					});
				}
			}

			createWebsocket();
		});
})(window.angular);
